/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ReceiptPage_viewer$ref = any;
export type queries_ReceiptPage_QueryVariables = {
    readonly orderApiId: string;
};
export type queries_ReceiptPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ReceiptPage_viewer$ref;
    }) | null;
};
export type queries_ReceiptPage_Query = {
    readonly response: queries_ReceiptPage_QueryResponse;
    readonly variables: queries_ReceiptPage_QueryVariables;
};



/*
query queries_ReceiptPage_Query(
  $orderApiId: String!
) {
  viewer {
    id
    ...ReceiptPage_viewer_xeX6W
  }
}

fragment ReceiptPage_viewer_xeX6W on Viewer {
  order(orderApiId: $orderApiId) {
    id
    orderId
    orderNumber
    email
    createDate
    orderStatus
    orderTotal
    orderItems {
      id
      quantity
      product {
        id
        inventoryClass
        inventoryQuantity
        productId
        isSubscription
        promoCodeDiscount {
          case4Cause {
            case12PriceUSD
            case6PriceUSD
          }
        }
      }
    }
    shippingInfo {
      tracking
      id
    }
    ...OrderItem_order
  }
  user {
    id
    ...OrderItem_user
    conciergeUser {
      id
    }
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
        preferredCustomer {
          access
        }
      }
    }
    orders(first: 2) {
      edges {
        node {
          id
          orderItems {
            id
            quantity
            priceBought
            product {
              id
              productId
              isSubscription
              name
              price
              priceSale
              productURLslug
              images {
                productCatalog
                squareFront
                id
              }
              promoCodeDiscount {
                case4Cause {
                  case12PriceUSD
                  case6PriceUSD
                }
              }
              content {
                impactSmall
                id
              }
              company
              inventorySKU
              inventoryClass
              inventoryText
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  isLoggedIn
}

fragment OrderItem_order on Order {
  id
  eventId
  event {
    id
    hostFullName
  }
  orderId
  orderNumber
  createDate
  orderStatus
  orderTotal
  orderTax
  orderSubTotal
  email
  isHostKitOrder
  isAutoShipOrder
  giftMessage {
    message
    recipientName
    from
  }
  giftReceipt
  isProcessing
  giftCards
  giftCardSavings
  promoCodes
  promoCodeSavings
  trinityTransmissionStatus
  trinityOrderId
  trinityPartyId
  orderItems {
    id
    quantity
    priceBought
    saleSavings
    product {
      id
      productId
      name
      price
      priceSale
      productURLslug
      staticUrl
      images {
        productCatalog
        squareFront
        id
      }
      content {
        impactSmall
        id
      }
      inventoryQuantity
      company
      inventorySKU
      inventoryClass
      inventoryText
      isSubscription
      promoCodeDiscount {
        case4Cause {
          case12PriceUSD
          case6PriceUSD
        }
      }
      productPermissions {
        oneCommerce {
          preferredCustomer {
            view
            add
          }
        }
      }
    }
  }
  shippingChosen
  shippingInfo {
    carrier
    tracking
    expectedDeliveryDate
    id
  }
  shippingAddress {
    firstName
    lastName
    specialInstructions
    street
    addressLineTwo
    city
    state
    zip
    phone
  }
  paymentInfo {
    name
    last4
    expYear
    expMonth
    billingAddressUuid
    provider
  }
  orderShipping
  billingAddressIsShippingAddress
  billingAddress {
    firstName
    lastName
    street
    addressLineTwo
    city
    state
    zip
  }
  recipientBirthDate
  pointsEarned
  pointsRedeemed
  rewardsCodeRedeemed
}

fragment OrderItem_user on User {
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
      preferredCustomer {
        access
      }
    }
  }
  conciergeUser {
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "orderApiId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isSubscription",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6PriceUSD",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "inventoryClass",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": null,
        "args": null,
        "concreteType": "Images",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "productCatalog",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "squareFront",
                "args": null,
                "storageKey": null
            },
            (v1 /*: any*/)
        ]
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "content",
        "storageKey": null,
        "args": null,
        "concreteType": "Content",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "impactSmall",
                "args": null,
                "storageKey": null
            },
            (v1 /*: any*/)
        ]
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "company",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "inventorySKU",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "inventoryText",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceBought",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "street",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineTwo",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v24 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v25 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v24 /*: any*/)
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_ReceiptPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ReceiptPage_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "orderApiId",
                                    "variableName": "orderApiId",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_ReceiptPage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "order",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "orderApiId",
                                    "variableName": "orderApiId",
                                    "type": "String"
                                }
                            ],
                            "concreteType": "Order",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isProcessing",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderNumber",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderStatus",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderTotal",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orderItems",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderItem",
                                    "plural": true,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "product",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryQuantity",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "staticUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "view",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "add",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        (v16 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "saleSavings",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ShippingInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "tracking",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "carrier",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expectedDeliveryDate",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "eventId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "event",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hostFullName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderTax",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderSubTotal",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isHostKitOrder",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isAutoShipOrder",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "giftMessage",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CartGiftMessageType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "message",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "recipientName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "from",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "giftReceipt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "giftCards",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "giftCardSavings",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "promoCodes",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "promoCodeSavings",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "trinityTransmissionStatus",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "trinityOrderId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "trinityPartyId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shippingChosen",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderAddress",
                                    "plural": false,
                                    "selections": [
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "specialInstructions",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "phone",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "paymentInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PaymentInfo",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last4",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expYear",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expMonth",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "billingAddressUuid",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "provider",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderShipping",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "billingAddressIsShippingAddress",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "billingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderAddress",
                                    "plural": false,
                                    "selections": [
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "recipientBirthDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pointsEarned",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pointsRedeemed",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "rewardsCodeRedeemed",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v24 /*: any*/)
                                                },
                                                (v25 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "userId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v25 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v1 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orders",
                                    "storageKey": "orders(first:2)",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 2,
                                            "type": "Int"
                                        }
                                    ],
                                    "concreteType": "OrderConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Order",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "orderItems",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "OrderItem",
                                                            "plural": true,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v16 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        (v1 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v15 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasPreviousPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_ReceiptPage_Query",
            "id": null,
            "text": "query queries_ReceiptPage_Query(\n  $orderApiId: String!\n) {\n  viewer {\n    id\n    ...ReceiptPage_viewer_xeX6W\n  }\n}\n\nfragment ReceiptPage_viewer_xeX6W on Viewer {\n  order(orderApiId: $orderApiId) {\n    id\n    orderId\n    orderNumber\n    email\n    createDate\n    orderStatus\n    orderTotal\n    orderItems {\n      id\n      quantity\n      product {\n        id\n        inventoryClass\n        inventoryQuantity\n        productId\n        isSubscription\n        promoCodeDiscount {\n          case4Cause {\n            case12PriceUSD\n            case6PriceUSD\n          }\n        }\n      }\n    }\n    shippingInfo {\n      tracking\n      id\n    }\n    ...OrderItem_order\n  }\n  user {\n    id\n    ...OrderItem_user\n    conciergeUser {\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    orders(first: 2) {\n      edges {\n        node {\n          id\n          orderItems {\n            id\n            quantity\n            priceBought\n            product {\n              id\n              productId\n              isSubscription\n              name\n              price\n              priceSale\n              productURLslug\n              images {\n                productCatalog\n                squareFront\n                id\n              }\n              promoCodeDiscount {\n                case4Cause {\n                  case12PriceUSD\n                  case6PriceUSD\n                }\n              }\n              content {\n                impactSmall\n                id\n              }\n              company\n              inventorySKU\n              inventoryClass\n              inventoryText\n            }\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n    }\n  }\n  isLoggedIn\n}\n\nfragment OrderItem_order on Order {\n  id\n  eventId\n  event {\n    id\n    hostFullName\n  }\n  orderId\n  orderNumber\n  createDate\n  orderStatus\n  orderTotal\n  orderTax\n  orderSubTotal\n  email\n  isHostKitOrder\n  isAutoShipOrder\n  giftMessage {\n    message\n    recipientName\n    from\n  }\n  giftReceipt\n  isProcessing\n  giftCards\n  giftCardSavings\n  promoCodes\n  promoCodeSavings\n  trinityTransmissionStatus\n  trinityOrderId\n  trinityPartyId\n  orderItems {\n    id\n    quantity\n    priceBought\n    saleSavings\n    product {\n      id\n      productId\n      name\n      price\n      priceSale\n      productURLslug\n      staticUrl\n      images {\n        productCatalog\n        squareFront\n        id\n      }\n      content {\n        impactSmall\n        id\n      }\n      inventoryQuantity\n      company\n      inventorySKU\n      inventoryClass\n      inventoryText\n      isSubscription\n      promoCodeDiscount {\n        case4Cause {\n          case12PriceUSD\n          case6PriceUSD\n        }\n      }\n      productPermissions {\n        oneCommerce {\n          preferredCustomer {\n            view\n            add\n          }\n        }\n      }\n    }\n  }\n  shippingChosen\n  shippingInfo {\n    carrier\n    tracking\n    expectedDeliveryDate\n    id\n  }\n  shippingAddress {\n    firstName\n    lastName\n    specialInstructions\n    street\n    addressLineTwo\n    city\n    state\n    zip\n    phone\n  }\n  paymentInfo {\n    name\n    last4\n    expYear\n    expMonth\n    billingAddressUuid\n    provider\n  }\n  orderShipping\n  billingAddressIsShippingAddress\n  billingAddress {\n    firstName\n    lastName\n    street\n    addressLineTwo\n    city\n    state\n    zip\n  }\n  recipientBirthDate\n  pointsEarned\n  pointsRedeemed\n  rewardsCodeRedeemed\n}\n\nfragment OrderItem_user on User {\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n      preferredCustomer {\n        access\n      }\n    }\n  }\n  conciergeUser {\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    id\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b47c1b993a18ce3394bef555ae605d35';
export default node;
